import type { Vec2 } from '../../geo/types';
import type { Channel } from '../../data/types';
import type { SiteQueries, WaterKind } from '../../site/types';
import { IJ_BODY_ID } from '../../data/waterClasses';
import { pointInPolygon } from '../../geo/polygon';
import type { WaterAreaSource } from './waterAreas';

// The body of the water of this kind at p: its channel, on the site or carried on past the bounds,
// the water area that holds it, or the IJ, which the site's queries give all other water.
export function bodyOfWater(
  channel: Channel | null,
  kind: WaterKind,
  areas: readonly WaterAreaSource[],
  p: Vec2
): string {
  if (channel) return channel.id;
  if (kind !== 'area') return IJ_BODY_ID;
  return areas.find((area) => pointInPolygon(p, area.polygon))?.id ?? IJ_BODY_ID;
}

/** The layout id of the body of water at p, or null off the water. */
export function waterBodyAt(
  queries: SiteQueries,
  areas: readonly WaterAreaSource[],
  p: Vec2
): string | null {
  if (!queries.isWater(p)) return null;
  const channel = queries.channelAt(p);
  const kind = channel?.kind ?? queries.waterKindAt(p);
  return kind === null ? null : bodyOfWater(channel, kind, areas, p);
}
